module.exports = __webpack_public_path__ + "static/media/the-queen-sky-snake.9a64deac.jpg";